"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debounce = void 0;
// https://gist.github.com/ca0v/73a31f57b397606c9813472f7493a940
const debounce = (func, waitFor) => {
    let timeout = null;
    const debounced = (...args) => {
        if (timeout !== null) {
            clearTimeout(timeout);
            timeout = null;
        }
        timeout = setTimeout(() => func(...args), waitFor);
    };
    return debounced;
};
exports.debounce = debounce;
//# sourceMappingURL=debounce.js.map